<template>
  <div class="main">
    <div class="bg">
      <div class="box">
        <div class="form">
          <div class="smile"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/activity/smile.png" alt=""></div>
          <div class="title">恭喜您，提交成功</div>
          <div class="title value">请凭此页面到工作人员处领取礼品</div>
          <div class="title value">我们会在三日内发送报告至您的邮箱</div>


        </div>
      </div>
      <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/activity/giftFinished.gif" alt=""></div>
      <div class="true">

      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {}
    };
  }
};
</script>

<style lang="scss" scoped>
.main {
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/activity/activity.jpg");
  background-size: contain;
  min-height: 100%;
  overflow: hidden;
  position: relative;
}
.box {
  //   padding: 200px;
  padding: 100px 0 50px 0;
  display: flex;
  justify-content: center;
}
.form {
  padding:300px 100px;
  padding-bottom: 0;
  width: 90%;
  // border: 1px solid #000;
  // background-color: #fff;
  border-radius: 50px;
  .title {
    font-size: 90px;
    text-align: center;
    margin-bottom: 50px;
    font-weight: 700;
  }
  .value {
    // padding-bottom: 500px;
    font-size: 70px;

    font-weight: 400;
    color: #868484;
  }
  .smile {
    text-align: center;
    margin-bottom: 50px;
    // padding-bottom: 400px;
    img {
      width: 40%;
    }
  }
  /deep/.el-form {
    // font-size: 90%;
    .el-form-item {
      .el-form-item__label {
        font-weight: 400;
        line-height: 100px;
        color: #868484;
        font-size: 60px;
      }
      .el-form-item__content {
        height: 200px;
        .el-input {
          //   border-radius: 50px;
          .el-input__inner {
            padding-left: 50px;
            background-color: #f6f7f9;
            border-radius: 30px;
            height: 130px;
            font-size: 70px;
          }
        }
      }
    }
  }
}
.img {
  text-align: center;

  height: 500px;
  img {
    position: absolute;
    width: 150%;
    top: 900px;
    left: -27%;
  }
}
.true {
  display: flex;
  justify-content: center;

  text-align: center;
  .button {
    border: 1px solid #000;
    border-radius: 50px;
    font-size: 70px;
    padding: 20px 0;
    width: 75%;
    margin-bottom: 50px;
  }
}
</style>